export const history = require("history").createHashHistory();
let oldLocation = null;
history.listen(location => {
  // Hook to scroll to top when route changes occurs
  if (oldLocation !== null) window.scrollTo(0, 0);
  oldLocation = location;
});
